var outputPS = `
`;

export { outputPS as default };
